import { Utilities } from '@approot/utilities';
import { LegHelperService } from './leg-helper.service';
import { Injectable, Renderer2 } from '@angular/core';
import {
  makeTextCustomColor,
  manuallyUpdateFormControlValidity,
  setCalculatedField
} from '../utilities/leg.utilities';
import { faceCurrencyChange } from '../utilities/currency-utilities';
import {
  counterNotionalAfterValuesSet,
  notionalChangeNoStrikeReCalc
} from '../utilities/notional-utilities';
import { ProductsConfigService } from '@approot/services';
import {
  getStrikeValue,
  LegSpotStrikeService
} from './leg-spot-strike.service';

@Injectable({
  providedIn: 'root'
})
export class LegNotionalService {
  constructor(
    private legHelperService: LegHelperService,
    private renderer: Renderer2,
    private productsConfigService: ProductsConfigService,
    private legSpotStrikeService: LegSpotStrikeService
  ) {}

  public handleNotionalSelectedRecords(
    notionalNumber: '' | '1' | '2',
    selectedField: string,
    affectNextField?: boolean
  ): void {
    const fieldsToBeEdited = this.legHelperService.fieldsToBeEdited;
    const leg = this.legHelperService.leg;
    const form = this.legHelperService.form;
    const fieldsToBeEditedValue = selectedField.includes('counterNotional')
      ? 'notional'
      : 'counterNotional'; // opposite field is the field that will be edited

    fieldsToBeEdited['notional' + notionalNumber] = fieldsToBeEditedValue;
    // make the opposite field grey

    const counterNotionalColor =
      'counterNotional' + notionalNumber === selectedField
        ? Utilities.whiteTextColor
        : Utilities.greyTextColor;

    const notionalColor =
      'notional' + notionalNumber === selectedField
        ? Utilities.whiteTextColor
        : Utilities.greyTextColor;
    makeTextCustomColor(
      'counterNotional' + notionalNumber,
      counterNotionalColor,
      leg
    );

    makeTextCustomColor('notional' + notionalNumber, notionalColor, leg);

    if (
      notionalNumber === '1' &&
      form.get('counterNotional2') &&
      form.get('notional2') &&
      affectNextField
    ) {
      fieldsToBeEdited['notional2'] = fieldsToBeEditedValue;
      makeTextCustomColor('counterNotional2', counterNotionalColor, leg);
      makeTextCustomColor('notional2', notionalColor, leg);
    }
    faceCurrencyChange(
      form,
      this.legHelperService.presetsLoaded,
      fieldsToBeEdited,
      leg,
      notionalNumber
    );
  }

  public notionalStrikeMultiplySetup(val: string, valueNumber: string): void {
    const form = this.legHelperService.form;
    const leg = this.legHelperService.leg;
    val = Utilities.notionalCurrencyRemover(val).toString().replace(/,/g, '');
    if (
      form.get('counterNotional' + valueNumber) &&
      form.get('notional' + valueNumber).valid
    ) {
      if (form.get('strike' + valueNumber).valid && !isNaN(+val) && +val) {
        // if there is a strike and notional calculate notional currency
        form.get('counterNotional' + valueNumber).setValue(
          !isNaN(getStrikeValue(form.get('strike' + valueNumber))) // if strike isn't a value then then set it to the empty string
            ? setCalculatedField(
                val,
                getStrikeValue(form.get('strike' + valueNumber)),
                '*'
              )
            : '',
          { emitEvent: false }
        );

        counterNotionalAfterValuesSet(
          valueNumber,
          form,
          leg,
          this.legHelperService.qs('#' + 'counterNotional' + valueNumber),
          this.renderer
        );

        // updateValidity Manual
        manuallyUpdateFormControlValidity(
          'counterNotional' + valueNumber,
          form
        );
      } else if (
        getStrikeValue(form.get('strike' + valueNumber)) === '' &&
        form.get('counterNotional' + valueNumber).valid &&
        form.get('notional' + valueNumber).valid &&
        +val
      ) {
        // if no strike and there is a notional and notional currency
        // calculate the notional Currency
        form
          .get('strike' + valueNumber)
          .setValue(
            (
              parseFloat(
                form
                  .get('counterNotional' + valueNumber)
                  .value.replace(/,/g, '')
              ) / +val
            ).toFixed(
              this.productsConfigService.decimalPlacesForCross(
                form.get('cross').value
              )
            ),
            { emitEvent: false }
          );
        form.get('strike' + valueNumber).updateValueAndValidity();
      }
    } else if (
      !getStrikeValue(form.get('strike' + valueNumber)) ||
      !form.get('notional' + valueNumber).value
    ) {
      form.get('counterNotional' + valueNumber).setValue('');
    }
  }

  public onNotionalChange(val: string, notionalNumber: string) {
    const form = this.legHelperService.form;
    const leg = this.legHelperService.leg;
    const rfqExecutionSettings = this.legHelperService.rfqExecutionSettings;
    if (
      form.get('notional' + notionalNumber) &&
      form.get('counterNotional' + notionalNumber) &&
      form.get('strike' + notionalNumber)
    ) {
      this.notionalStrikeMultiplySetup(val, notionalNumber);
    }

    if (!rfqExecutionSettings.directRfq) {
      this.legSpotStrikeService.onStrikeCalc(notionalNumber); // convert the strike special values into a number
    }
    notionalChangeNoStrikeReCalc(
      notionalNumber,
      form,
      leg,
      rfqExecutionSettings,
      this.legHelperService.qs('#' + 'notional' + notionalNumber),
      this.renderer
    );
    if (
      notionalNumber === '1' &&
      form.get('notional2') &&
      this.legHelperService.presetsLoaded
    ) {
      // when notional1 changes set notional2 to the same value
      form.get('notional2').setValue(val);
    }

    // carries out the remaining things that need to be done after calc with strike
  }
}
